export default __webpack_public_path__ + "static/vitaliy-aa4069c7b8e5e59d72cbe3eafe05d284.png";